import React from 'react';
import { handleKeyboardActivation } from '../../utils/keyboard';

interface SelectableCardProps {
  selected: boolean;
  onClick: () => void;
  badge?: string;
  badgeClassName?: string;
  className?: string;
  children: React.ReactNode;
}

export default function SelectableCard({
  selected,
  onClick,
  badge,
  badgeClassName = '',
  className = '',
  children,
}: SelectableCardProps) {
  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => handleKeyboardActivation(e, onClick)}
      className={`w-full text-left bg-white rounded-2xl p-[18px] relative transition-all cursor-pointer ${
        selected ? 'border-[3px] border-[#008BBC] shadow-md' : 'border-2 border-[#e0e0e0] hover:border-gray-300'
      } ${className}`}
    >
      {badge && (
        <span
          className={`absolute -top-2.5 left-1/2 -translate-x-1/2 bg-[#008BBC] text-white text-[0.6rem] font-bold px-2.5 py-0.5 rounded-lg uppercase tracking-wider whitespace-nowrap ${badgeClassName}`}
        >
          {badge}
        </span>
      )}
      <div
        className={`absolute top-2.5 right-2.5 w-6 h-6 rounded-full flex items-center justify-center ${
          selected ? 'bg-[#008BBC]' : 'border-2 border-gray-300'
        }`}
      >
        {selected && <span className="text-white text-xs font-bold">✓</span>}
      </div>
      {children}
    </div>
  );
}
